"use client"

import { reatomComponent } from "@reatom/react"
import { useQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import type { PropsWithChildren } from "react"
import { BffApiClientMolecule } from "../api-client/store"
import { useSyncQueryToAtom } from "../reatom/use-sync-query-to-atom"
import { BlockchainsMoleculeReatom } from "./blockchain-molecule.reatom"
import { getBlockchainsQueryParams } from "./get-blockchains-query-params"

/**
 * Provider that fetches blockchains data and syncs it to Reatom atom
 * Uses reatomQuery pattern
 *
 * This provider:
 * 1. Fetches blockchain configs from BFF
 * 2. Automatically syncs TanStack Query state to Reatom atom
 * 3. Makes blockchain data available to all components via BlockchainsMoleculeReatom
 */
export const BlockchainsDataProviderReatom = reatomComponent(
  ({ children }: PropsWithChildren) => {
    const bffApiClient = useMolecule(BffApiClientMolecule)
    const { blockchains } = useMolecule(BlockchainsMoleculeReatom)

    const queryParams = getBlockchainsQueryParams(bffApiClient)

    const query = useQuery(queryParams)

    // Automatically sync query to atom
    useSyncQueryToAtom(blockchains, query)

    return <>{children}</>
  },
  "BlockchainsDataProviderReatom",
)
